'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { Tooltip } from 'src/components/PulseUI';

interface ProfileTreatingVolumeItemProps {
  title: string;
  value: string;
  icon: IconProp;
  tooltip?: string;
}

const ProfileTreatingVolumeItem: React.FC<ProfileTreatingVolumeItemProps> = ({
  title,
  value,
  icon,
  tooltip,
}) => {
  const testId = `profile-treating-volume-item-${title.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <div
      className="self-stretch h-28 px-6 py-5 bg-white rounded-lg border
              border-neutral-200 inline-flex flex-col justify-center items-start gap-2 overflow-hidden"
      data-testid={testId}
      role="group"
      aria-label={`${title}: ${value}`}
    >
      <div className="self-stretch inline-flex justify-between items-start">
        <div className="flex justify-center items-center gap-1">
          <div className="w-5 h-5 flex items-center justify-center">
            <Icon icon={icon} className="text-tertiary w-4 h-4" aria-hidden="true" />
          </div>
          <div className="justify-start text-tertiary text-sm font-normal font-['Inter'] leading-5 line-clamp-1">
            {title}
          </div>
        </div>
        <Tooltip content={tooltip || "The sum of all claims volume from all codes within all codesets"}>
          <div className="w-6 h-6 flex items-center justify-center cursor-pointer">
            <Icon icon={faCircleInfo} className="text-tertiary w-4 h-4" aria-hidden="true" />
          </div>
        </Tooltip>
      </div>
      <div
        className="justify-start text-primary text-3xl font-extrabold font-['Inter'] leading-9"
        aria-live="polite"
      >
        {value}
      </div>
    </div>
  );
};

export default ProfileTreatingVolumeItem;
